// Plataforma nueva (crm.wiservet.com, API :8083). Build separado del de
// wiservet.com: no comparte entrada, ni service worker, ni cookie de sesión.
import { createApp } from 'vue';
import { createPinia } from 'pinia';
import PrimeVue from 'primevue/config';

import App from './App.vue';
import { buildRouter } from './router';
import { useSessionStore } from './session/store';
import { cleanupLegacyServiceWorkerAndReload } from './session/swCleanup';
import { createVersionChecker, fetchPublishedVersion } from './version/versionCheck';

import 'primeicons/primeicons.css';
import '@/design-system/tokens.css';
import '@/design-system/crm-tokens.css';
import '@/design-system/crm-base.css';
import './pn.css';

// 1) Fuera el service worker del CRM de mayo (si la página aún venía de su caché).
void cleanupLegacyServiceWorkerAndReload();

// 2) Versión nueva sin recarga forzada del usuario.
export const versionChecker = createVersionChecker({
  current: __PN_VERSION__,
  fetchVersion: fetchPublishedVersion,
});
versionChecker.start();

const app = createApp(App);
const pinia = createPinia();
app.use(pinia);
const router = buildRouter(versionChecker);
app.use(router);
app.use(PrimeVue, { unstyled: true });
app.provide('versionChecker', versionChecker);

// 3) Al volver a la pestaña: chequear versión y renovar la sesión si hace falta.
document.addEventListener('visibilitychange', () => {
  if (document.visibilityState !== 'visible') return;
  void versionChecker.check();
  void useSessionStore(pinia).onVisible();
});

app.mount('#app');
